<div class="container">
  <div class="text-left">
    <div class="breadcrumb flat">
      <a [routerLink]="['/pos']"> Home</a>
      <a [routerLink]="['/pos/orderreceipt/manage']">Manage Order</a>
      <a href="#" class="active"> New Order </a>
    </div>
  </div>
  <div>
    <div class="content bg-light">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-outline-secondary">
              <div class="card-header blue-bg">
                <h4 class="mb-0">View Order Details</h4>
              </div>
              <div class="card-body shadow right-img">
                
                <div class="row m-0">
                  <div class="col-md-7 mb-2 bg-light cover">
                    <div class="row  border-bottom p-1 m-3">
                      <div class="col-4 p-0">Order Id</div>
                      <div class="col-1 d-none d-sm-block">:</div>
                      <div class="col-7 p-0">{{rows.id}}</div>
                    </div>
                    <div class="row  border-bottom p-1 m-3">
                      <div class="col-md-4  p-0"> AutoMatic Group Similar Itmes</div>
                      <div class="col-1 d-none d-sm-block">:</div>
                      <div class="col-7 p-0">
                          <input type="checkbox"  [(ngModel)]="rows.autoMaticGroupSimilarItmes" id="AutoMaticGroupSimilarItmes" name="AutoMaticGroupSimilarItmes">
                      </div>
                    </div>
                    <div class="row  border-bottom p-1 m-3">
                      <div class="col-md-4  p-0">Allow Notes On Orders</div>
                      <div class="col-1 d-none d-sm-block">:</div>
                      <div class="col-7 p-0"> 
                          <input type="checkbox"  [(ngModel)]="rows.allowNotesOnOrders" id="AllowNotesOnOrders" name="AllowNotesOnOrders">
                      </div>
                    </div>
                   
                   
                 
                    <div class="text-right pt-2">
                      <button class="damke_siteBtn" id="accountDataList"
                        [routerLink]="['/pos/order/manage']">Back</button>
                    </div>
                  
                  </div>
                  <div class="col-md-5">
                    <div class="col-12 col-md-10">
                      <div class="border w-75  d-block mx-auto mx-md-0">
                        <h4 class="blue-t py-2 text-center">Quick Links</h4>
                        <ul class="list-group list-group-flush">
                          <li class="list-group-item"><a [routerLink]="['/pos']">Home</a></li>
                          <li class="list-group-item"><a [routerLink]="['/pos/order/new']">New Order SetUp</a>
                          </li>

                          <li class="list-group-item"><a [routerLink]="['/pos/order/manage']">Manage
                              Order SetUp</a> </li>
                        
                        </ul>
                      </div>
                    </div>
                    <div class="pt-2">
                      <h4 class="blue-t p-2" style="font-family: 'Oswald', sans-serif;">Tips</h4>
                      <carousel [itemsPerSlide]="1" [singleSlideOffset]="false" [noWrap]="false" [interval]="3000"
                        [startFromIndex]="0">

                        <slide>
                          <a [routerLink]="['/transactions/faqs']"><img src="assets/img/collecting-money.png" alt="First slide"
                              style="display: block; width: 100%;"></a>
                        </slide>
                        <slide>
                          <a [routerLink]="['/transactions/faqs']"><img src="assets/img/payment-solutions.png" alt="Third slide"
                              style="display: block; width: 100%;"></a>
                        </slide>
                      </carousel>
                    </div>
                  </div>
                </div>
               

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    

    


  </div>
</div>


  






 